import "./ServiceCallItem.css"

const serviceCallItemConstants = {
    height: 50,
    fontSize: 12,
    childrenLine: {
        color: '#495C83'
    },
    levelPadding: 10,
    barHeight: 20,
};


const ServiceCallItem = ({xScale, yScale,  serviceColor, callData }) => {
    const {id, name, duration, start} = callData;

    const fieldHasLatency = duration > 0

    return fieldHasLatency && <rect
                key={`rect-${id}`}
                y={`${yScale(id) + ((yScale.bandwidth() - serviceCallItemConstants.barHeight) / 2)}`}
                x={`${xScale(start)}`}
                width={`${xScale(duration)}`}
                height={`${serviceCallItemConstants.barHeight}`}
                fill={serviceColor(name)}
                ry={serviceCallItemConstants.height / 10}
            />

}

export default  ServiceCallItem;
export {
    serviceCallItemConstants
}
